export default function Footer() {
  return (
    <footer className="Footer">
      <div className="Footer-text-container">
        <p className="Footer-text">{`© 2023 All Rights Reserved`}</p>
      </div>
    </footer>
  );
}
